<template>
  <div class="product-container">
    <div class="page-header">
      <h2>小微企业贷款产品管理</h2>
      <el-button type="primary" @click="handleAddProduct">
        <i class="el-icon-plus"></i> 添加产品
      </el-button>
    </div>

    <!-- 产品列表 -->
    <el-table
      :data="productList"
      border
      style="width: 100%"
      max-height="600px"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column
        prop="name"
        label="产品名称"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="maxAmount"
        label="额度最高"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="maxTerm"
        label="最长期限"
        width="120"
      ></el-table-column>
      <el-table-column prop="features" label="产品特色"></el-table-column>
      <el-table-column prop="isRecommend" label="是否推荐" width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isRecommend"
            @change="handleRecommendChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="update_time"
        label="更新时间"
        width="180"
      ></el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleViewDetail(scope.row)"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="handleEditProduct(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDeleteProduct(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 产品表单对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <el-form
        :model="productForm"
        :rules="rules"
        ref="productForm"
        label-width="100px"
      >
        <el-form-item label="产品名称" prop="name">
          <el-input
            v-model="productForm.name"
            placeholder="请输入产品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="最高额度" prop="maxAmount">
          <el-input
            v-model="productForm.maxAmount"
            placeholder="请输入最高额度"
          >
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="最长期限" prop="maxTerm">
          <el-input v-model="productForm.maxTerm" placeholder="请输入最长期限">
            <template slot="append">年</template>
          </el-input>
        </el-form-item>
        <el-form-item label="产品特色" prop="features">
          <el-input
            v-model="productForm.features"
            placeholder="请输入产品特色"
          ></el-input>
        </el-form-item>
        <el-form-item label="适用对象" prop="targets">
          <el-input
            type="textarea"
            :rows="3"
            v-model="productForm.targets"
            placeholder="请输入适用对象"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品描述" prop="description">
          <el-input
            type="textarea"
            :rows="4"
            v-model="productForm.description"
            placeholder="请输入产品描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否推荐" prop="isRecommend">
          <el-switch v-model="productForm.isRecommend"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 产品详情对话框 -->
    <el-dialog title="产品详情" :visible.sync="detailVisible" width="60%">
      <div class="product-detail" v-if="currentProduct">
        <div class="detail-header">
          <h3>{{ currentProduct.name }}</h3>
          <el-tag v-if="currentProduct.isRecommend" type="success">推荐</el-tag>
        </div>
        <div class="detail-info">
          <div class="info-item">
            <span class="label">最高额度：</span>
            <span class="value">{{ currentProduct.maxAmount }}万元</span>
          </div>
          <div class="info-item">
            <span class="label">最长期限：</span>
            <span class="value">{{ currentProduct.maxTerm }}年</span>
          </div>
          <div class="info-item">
            <span class="label">产品特色：</span>
            <span class="value">{{ currentProduct.features }}</span>
          </div>
        </div>
        <div class="detail-section">
          <h4>产品描述</h4>
          <p>{{ currentProduct.description }}</p>
        </div>
        <div class="detail-section">
          <h4>适用对象</h4>
          <p>{{ currentProduct.targets }}</p>
        </div>
        <div class="detail-section">
          <h4>更新时间</h4>
          <p>{{ currentProduct.update_time }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInfo, addInfo, editInfo, delInfo } from "@/api";
export default {
  name: "ProductManagement",
  data() {
    return {
      loading: false, // 加载状态标志
      productList: [], // 产品列表数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0, // 总记录数
      dialogVisible: false, // 表单对话框显示状态
      dialogTitle: "添加产品", // 对话框标题
      detailVisible: false, // 详情对话框显示状态
      currentProduct: null, // 当前查看的产品详情
      isEdit: false, // 是否为编辑模式
      editId: "", // 编辑时的产品ID
      // 产品表单数据对象
      productForm: {
        name: "", // 产品名称
        maxAmount: "", // 最高额度
        maxTerm: "", // 最长期限
        features: "", // 产品特色
        targets: "", // 适用对象
        description: "", // 产品描述
        isRecommend: false, // 是否推荐
      },
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "长度在 2 到 30 个字符",
            trigger: "blur",
          },
        ],
        maxAmount: [
          { required: true, message: "请输入最高额度", trigger: "blur" },
        ],
        maxTerm: [
          { required: true, message: "请输入最长期限", trigger: "blur" },
        ],
        features: [
          { required: true, message: "请输入产品特色", trigger: "blur" },
        ],
        targets: [
          { required: true, message: "请输入适用对象", trigger: "blur" },
        ],
        description: [
          { required: true, message: "请输入产品描述", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getProductList(); // 获取产品列表数据
  },
  methods: {
    // 获取产品列表数据
    getProductList() {
      this.loading = true; // 显示加载状态
      // 调用API接口获取数据
      getInfo({
        model: "product", // 模型名称
        condition: {}, // 查询条件
        page: this.currentPage, // 当前页码
        pagesize: this.pageSize, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.productList = res.data.data; // 设置产品列表数据
          this.total = res.data.page_info.total_size; // 设置总记录数
          this.loading = false; // 隐藏加载状态
        }
      });
    },

    // 分页处理函数
    handleSizeChange(val) {
      this.pageSize = val; // 更新每页显示条数
      this.getProductList(); // 重新获取列表数据
    },
    handleCurrentChange(val) {
      this.currentPage = val; // 更新当前页码
      this.getProductList(); // 重新获取列表数据
    },

    // 添加产品
    handleAddProduct() {
      this.isEdit = false; // 设置为添加模式
      this.editId = ""; // 清空编辑ID
      this.dialogTitle = "添加产品"; // 设置对话框标题
      this.resetForm(); // 重置表单数据
      this.dialogVisible = true; // 显示对话框
    },

    // 编辑产品
    handleEditProduct(row) {
      this.isEdit = true; // 设置为编辑模式
      this.editId = row._id; // 设置编辑ID
      this.dialogTitle = "编辑产品"; // 设置对话框标题
      // 复制行数据到表单
      this.productForm = {
        name: row.name,
        maxAmount: row.maxAmount,
        maxTerm: row.maxTerm,
        features: row.features,
        targets: row.targets,
        description: row.description,
        isRecommend: row.isRecommend,
      };
      this.dialogVisible = true; // 显示对话框
    },

    // 查看产品详情
    handleViewDetail(row) {
      this.currentProduct = row; // 设置当前产品
      this.detailVisible = true; // 显示详情对话框
    },

    // 删除产品
    handleDeleteProduct(row) {
      // 显示确认对话框
      this.$confirm("确认删除该产品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 用户确认删除
          this.editId = row._id; // 设置要删除的ID
          // 调用删除API
          delInfo({
            model: "product", // 模型名称
            _id: this.editId, // 要删除的ID
          }).then((res) => {
            if (res.status == 200) {
              this.$message.success("删除成功"); // 显示成功消息
              this.getProductList(); // 重新获取列表数据
            }
          });
        })
        .catch(() => {
          // 用户取消删除
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 修改推荐状态
    handleRecommendChange(row) {
      // 调用更新API
      editInfo({
        model: "product", // 模型名称
        condition: {}, // 查询条件
        _id: row._id, // 要编辑的ID
        data: {
          isRecommend: row.isRecommend, // 更新推荐状态
        },
      }).then((res) => {
        if (res.status == 200) {
          // 显示成功消息
          this.$message({
            type: "success",
            message: row.isRecommend ? "已设为推荐产品" : "已取消推荐",
          });
          this.getProductList(); // 重新获取列表数据
        }
      });
    },

    // 重置表单
    resetForm() {
      if (this.$refs.productForm) {
        this.$refs.productForm.resetFields(); // 重置表单验证状态
      }
      // 重置表单数据
      this.productForm = {
        name: "",
        maxAmount: "",
        maxTerm: "",
        features: "",
        targets: "",
        description: "",
        isRecommend: false,
      };
    },

    // 提交表单
    submitForm() {
      this.$refs.productForm.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            // 编辑操作
            editInfo({
              model: "product", // 模型名称
              condition: {}, // 查询条件
              _id: this.editId, // 要编辑的ID
              data: {
                ...this.productForm, // 表单数据
              },
            }).then((res) => {
              if (res.status == 200) {
                this.$message.success(this.dialogTitle + "成功"); // 显示成功消息
                this.dialogVisible = false; // 关闭对话框
                // 注意：这里应该是赋值操作 =，而不是比较操作 ==
                this.currentPage = 1; // 重置为第一页
                this.getProductList(); // 重新获取列表数据
              }
            });
          } else {
            // 添加操作
            addInfo({
              model: "product", // 模型名称
              condition: {}, // 查询条件
              data: {
                ...this.productForm, // 表单数据
              },
            }).then((res) => {
              if (res.status == 200) {
                this.$message.success(this.dialogTitle + "成功"); // 显示成功消息
                this.dialogVisible = false; // 关闭对话框
                // 注意：这里应该是赋值操作 =，而不是比较操作 ==
                this.currentPage = 1; // 重置为第一页
                this.getProductList(); // 重新获取列表数据
              }
            });
          }
        } else {
          return false; // 表单验证失败
        }
      });
    },
  },
};
</script>

<style scoped>
.product-container {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
}

.page-header h2 {
  font-size: 22px;
  color: #303133;
  margin: 0;
  font-weight: 600;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

/* 表格样式优化 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
}

.el-table /deep/ th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.el-table /deep/ .el-button--mini {
  padding: 6px 10px;
  font-size: 12px;
}

/* 产品详情对话框样式 */
.product-detail {
  padding: 10px;
}

.detail-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

.detail-header h3 {
  margin: 0;
  font-size: 20px;
  color: #303133;
  margin-right: 10px;
}

.detail-info {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  background-color: #f8f9fb;
  padding: 15px;
  border-radius: 6px;
}

.info-item {
  width: 33.33%;
  margin-bottom: 10px;
}

.label {
  color: #606266;
  font-size: 14px;
  margin-right: 5px;
}

.value {
  color: #303133;
  font-weight: 500;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-section h4 {
  font-size: 16px;
  color: #303133;
  margin-bottom: 10px;
  font-weight: 500;
}

.detail-section p {
  color: #606266;
  line-height: 1.6;
  margin: 0;
  white-space: pre-line;
}

/* 表单对话框样式 */
/deep/ .el-dialog__header {
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  color: #303133;
  font-weight: 600;
}

/deep/ .el-dialog__body {
  padding: 30px 20px;
}

/deep/ .el-form-item__label {
  font-weight: 500;
}

/deep/ .el-textarea__inner {
  font-family: inherit;
}

/deep/ .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid #ebeef5;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .info-item {
    width: 50%;
  }

  .el-table {
    width: 100%;
    overflow-x: auto;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .page-header h2 {
    margin-bottom: 15px;
  }
}
</style>